import React from 'react';
import { motion } from 'framer-motion';
import { Camera, Truck, CheckCircle2, MessageSquare } from 'lucide-react';
import { Button } from './ui/button';
export function HowItWorks() {
  const steps = [{
    number: '01',
    icon: Camera,
    title: 'TEXT A PHOTO',
    description: "Snap a pic of your junk and text it to us. That's your quote."
  }, {
    number: '02',
    icon: Truck,
    title: 'WE SHOW UP',
    description: 'Same-day or scheduled. Clean trucks, polite crew, uniformed.'
  }, {
    number: '03',
    icon: CheckCircle2,
    title: 'JUNK GONE',
    description: "We load, haul, sweep up. You pay only when you're happy."
  }];
  return <section id="how-it-works" className="relative py-20 md:py-28 bg-gradient-to-b from-navy to-[#0a0f1a]" data-id="element-109">
      {/* Blueprint grid pattern overlay */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: `
          linear-gradient(rgba(163, 230, 53, 0.5) 1px, transparent 1px),
          linear-gradient(90deg, rgba(163, 230, 53, 0.5) 1px, transparent 1px)
        `,
      backgroundSize: '40px 40px'
    }} data-id="element-110" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-111">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-16 md:mb-20" data-id="element-112">
          <h2 className="font-heading text-5xl md:text-6xl lg:text-7xl text-white tracking-wider mb-4" data-id="element-113">
            BOOK IN <span className="text-lime" data-id="element-114">UNDER 60 SECONDS</span>
          </h2>
          <div className="w-32 h-1 bg-lime mx-auto" data-id="element-115" />
        </motion.div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8 md:gap-12 relative" data-id="element-116">
          {steps.map((step, index) => <motion.div key={step.number} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative" data-id="element-117">
              <div className="relative z-10 text-center space-y-4" data-id="element-118">
                {/* Step number badge */}
                <div className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-lime" data-id="element-119">
                  <span className="font-bold text-navy text-sm leading-none" data-id="element-120">
                    {step.number.replace('0', '')}
                  </span>
                </div>

                {/* Icon */}
                <div className="inline-flex items-center justify-center w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-lime/10 border-2 border-lime shadow-[0_0_25px_rgba(163,230,53,0.4)]" data-id="element-121">
                  <step.icon className="w-10 h-10 md:w-12 md:h-12 text-lime" strokeWidth={2} data-id="element-122" />
                </div>

                {/* Title */}
                <h3 className="font-heading text-3xl md:text-4xl text-lime tracking-wider" data-id="element-123">
                  {step.title}
                </h3>

                {/* Description */}
                <p className="text-white/80 text-lg leading-relaxed max-w-xs mx-auto" data-id="element-124">
                  {step.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.8
      }} className="text-center mt-16" data-id="element-125">
          <a href="sms:4252697387" className="inline-flex" data-id="element-126">
            <Button size="lg" className="bg-lime text-navy hover:bg-lime/90 font-bold text-lg px-8 h-14 rounded-full shadow-[0_0_20px_rgba(163,230,53,0.5)] hover:shadow-[0_0_30px_rgba(163,230,53,0.7)] transition-all" data-id="element-127">
              <MessageSquare className="w-5 h-5 mr-2" data-id="element-128" />
              TEXT US A PHOTO NOW
            </Button>
          </a>
        </motion.div>
      </div>
    </section>;
}